module.exports = __webpack_public_path__ + "static/img/SSEP8.623c298.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/schoolEnrollment/SSEP8.jpg
// module id = c63B
// module chunks = 1